<template>
  <div>
    <b-modal v-model="showModal"
      :title="textMessage"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      @hidden="resetForm"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      no-enforce-focus>

        <form autocomplete="off" @submit.prevent="submitForm" enctype="multipart/form-data">
          <div class="modal-body">
            <div class="row container-fluid">
              <div class="form-group col-md-12">
                <label for="course"><b>Curso&nbsp;<span class="asterisk">*</span></b></label>
                <input v-model="form.course" type="text" class="form-control" id="course" name="course" placeholder="Curso">
                <span v-if="courseValid" class="text-danger" style="font-size: 10px;"><b>El campo Curso es requerido.</b></span>
              </div>
              <div class="form-group col-md-12">
                <label for=""><b>Descripción&nbsp;</b></label>
                <ckeditor ref="editor" v-model="form.description" :editor="editor" type="classic" :config="editorConfig"></ckeditor>
              </div>

              <div class="form-group col-md-4">
                <label for="course"><b>Dias&nbsp;<span class="asterisk">*</span></b></label>
                <input v-model="form.time" type="number" class="form-control" id="time" name="time" @keydown="onlyNumber">
                <cite class="" style="font-size: 10px;">Dias para culminar el curso</cite>
                <br v-if="timeValid==true">
                <span v-if="timeValid==true" class="text-danger" style="font-size: 10px;"><b>El campo Dias es requerido.</b></span>
              </div>

              <div class="form-group col-md-8">
                <label for=""><b>Video&nbsp;</b></label>
                <input ref="video" @change="handleFileChange" type="file" class="form-control" id="video" name="video" accept="video/mp4">
                <cite v-if="form.video && !(form.video instanceof File)" style="font-size: 10px;">El curso ya posee un video; si sube otro, lo reemplaza.</cite>
              </div>

              <input v-model="form.id" type="hidden" class="form-control" id="id" name="id">
            </div>

          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-danger" type="button" @click="cancel"> <i class="fas fa-times fa-fw"></i>Cancelar</button>
            <button type="submit" class="btn btn-sm btn-success"> <i class="fas fa-download fa-fw"></i> Guardar</button>
          </div>
        </form>

    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal } from 'bootstrap-vue';
import { ClassicEditor, editorConfig } from '../../../../ckeditor';
import CKEditor from '@ckeditor/ckeditor5-vue2';

export default {
  components: {BModal, 'ckeditor': CKEditor.component},
  props: ['id', 'showModal'],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig,
      name: 'ckeditor',
      form: {
        video: null, // Aquí almacenaremos el archivo seleccionado
        description: '',
        course: '',
        time: '',
      },
      courseValid: false,
      timeValid: false,
      loading: false,
      textMessage: 'Crear Curso',
    }
  },
  methods:{
    handleFileChange(event) {
      // Capturar el archivo seleccionado y asignarlo a la propiedad del formulario
      this.form.video = event.target.files[0] || null;
    },
    close(bvModalEvent) {
      this.resetForm();
      this.textMessage = 'Crear Curso'
      this.$emit('update:showModal', false)
      this.$emit('getRecords')
    },
    cancel(bvModalEvent) {
      this.resetForm();
      this.textMessage = 'Crear Curso'
      this.$emit('update:showModal', false)
    },
    resetForm() {
      // Este método se ejecutará cuando el modal se oculte
      this.form = {
        video: null,
        description: '',
        course: '',
        time: '',
      };
      // El input de archivo no se reinicia solo: el modal no se destruye al cerrarse
      if (this.$refs.video) {
        this.$refs.video.value = '';
      }
      this.courseValid= false,
      this.timeValid= false
    },
    getRecord() {
      this.loading = true

      if(this.id) {
        axios.get(`/administration/courses/courses/${this.id}`)
        .then(response => {
          this.textMessage = 'Editar Curso'
            this.form = response.data
        })
        .finally(() => {
          this.loading = false
        })
      } else {
        this.form = {
          video: null,
          description: '',
          course: '',
          time: '',
        }
      }
    },
    submitForm() {
      this.loading = true;
      this.courseValid = false;
      this.timeValid = false;

      // Validar campos
      if (this.form.course == '' || this.form.course == null) {
        this.courseValid = true;
      }

      if (this.form.time == '' || this.form.time == null) {
        this.timeValid = true;
      }

      // Si algún campo no es válido, detener el envío del formulario
      if (this.courseValid == true || this.timeValid == true) {
        return;
      }

      let formData = new FormData();
      // Verificar si this.id está definido
      if (this.id) {
        formData.append('id', this.form.id);
      } else {
        // Si this.id no está definido, asignar null a this.form.id
        this.form.id = null;
      }
      formData.append('course', this.form.course);
      formData.append('description', this.form.description);
      formData.append('time', this.form.time);
      // Solo se adjunta si se eligió un archivo nuevo; si no, se conserva el video actual
      if (this.form.video instanceof File) {
        formData.append('video', this.form.video);
      }

      axios.post('/administration/courses/courses', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(response => {
        if (response.data.status == 'error') {
          toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
        } else {
          toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
        }
        this.close();
      })
      .catch(error => {
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          toastr.error(Object.values(errors)[0][0], 'Error', { icon: 'fa fa-times-circle' });
        } else if (error.response && error.response.status === 413) {
          toastr.error('El video supera el tamaño máximo permitido por el servidor.', 'Error', { icon: 'fa fa-times-circle' });
        } else {
          toastr.error('No se pudo guardar el registro', 'Error', { icon: 'fa fa-times-circle' });
        }
      })
      .finally(() => {
        this.loading = false;
      });
    },
    onlyNumber(e) {
      var key = window.Event ? e.which : e.keyCode;

      // Rango de códigos de tecla para números en el teclado principal y en el teclado numérico
      if (!((key >= 48 && key <= 57) ||  // Teclas numéricas en el teclado principal
            (key >= 96 && key <= 105))) { // Teclas numéricas en el teclado numérico
        e.preventDefault();
      }
    },
  }
}

</script>

<style>
#__BVID__6___BV_modal_outer_ {
  /*z-index: 1000 !important;*/
  z-index: calc(var(--ck-z-panel) + 40) !important;
}
.ck-rounded-corners .ck.ck-balloon-panel {
  z-index: calc(var(--ck-z-panel) + 41) !important;
}
</style>